import { GetterTree } from 'vuex';
import BookingState from '@/types/store/booking/BookingState';
import RootState from '@/types/store/booking/RootState';
import CommuneProjection from '@/types/projections/CommuneProjection';
import Booking from '@/types/taxcard/Booking';
import BookingPriceProjection from '@/types/projections/BookingPriceProjection';
import AccommodationProjection from '@/types/projections/AccommodationProjection';

const getters: GetterTree<BookingState, RootState> = {
  communes(state): CommuneProjection[] {
    return state.communes;
  },
  currentBooking(state): Booking | null {
    return state.currentBooking;
  },
  currentBookingSession(state): number | null {
    return state.currentBookingSession;
  },
  currentPriceProjection(state): BookingPriceProjection | null {
    return state.currentPriceProjection;
  },
  currentOrderId(state): string | null {
    return state.currentOrderId;
  },
  accommodations: (state): AccommodationProjection[] => state.accommodations,
  currentPaymentMethod: (state): string | null => state.currentPaymentMethod,
  downcasedPaymentMethod: (state): string =>
    state.currentPaymentMethod ? state.currentPaymentMethod.toLowerCase() : '',
};

export default getters;
